import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Card, Alert } from "react-bootstrap";
import "../style/forgotPassword.css";
import APIFunction from "../util/api";
import { INFO_STATEMENTS, ERROR_MESSAGES } from "../util/constants";

const ForgotPasswordForm = () => {
  const [formData, setFormData] = useState({
    email: ''
  });
  const [showAlert, setShowAlert] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [alertMsg, setAlertMsg] = useState(INFO_STATEMENTS.PASSWORD_RESET_SENT)

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowAlert(false);
    setAlertMsg('');
    setIsSubmitting(true);
    
    try {
      const payload = {
        email: formData.email
      };
      await APIFunction.requestPasswordReset(payload);
      setAlertMsg(INFO_STATEMENTS.PASSWORD_RESET_SENT);
      setFormData({ email: '' });
      setShowAlert(true);
      setIsSubmitting(false);
    } catch (err) {
      console.error(err);
      setAlertMsg(ERROR_MESSAGES.PASSWORD_RESET_FAILED);
      setFormData({ email: '' });
      setShowAlert(true);
      setIsSubmitting(false);
    }
  };

  return (
    <section className="forgotPasswordSection">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} lg={6}>
            <Card className="shadow-lg border-0">
              <Card.Body className="p-5">
                <div className="text-center mb-4">
                  <h2 className="fw-bold text-secondary">Forgot Password?</h2>
                  <p className="text-muted">
                    Enter your email address and we'll send you a link to reset your password.
                  </p>
                </div>
                
                {showAlert && alertMsg === INFO_STATEMENTS.PASSWORD_RESET_SENT && (
                  <Alert variant="success" className="mb-4">
                    <i className="bi bi-check-circle-fill me-2"></i>{alertMsg}</Alert>
                )}

                {showAlert && alertMsg === ERROR_MESSAGES.PASSWORD_RESET_FAILED && (
                  <Alert variant="danger">
                      <i className="bi bi-exclamation-triangle me-2"></i>{alertMsg}</Alert>
                )}
                
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-4">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter your email address"
                      required
                      disabled={isSubmitting}
                    />
                  </Form.Group>
                  
                  <div className="d-grid mb-4">
                    <Button 
                      variant="primary" 
                      type="submit" 
                      size="lg"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Sending...
                        </>
                      ) : (
                        <>
                          Send Reset Link <i className="bi bi-envelope"></i>
                        </>
                      )}
                    </Button>
                  </div>
                  
                  <div className="text-center">
                    <p className="text-muted">
                      Remember your password? <a href="/login" className="text-primary">Back to Login</a>
                    </p>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ForgotPasswordForm;
